import React, { useEffect, useState } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./Clients.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import api from "./Dashboard/Api";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faCrown,
  faStar,
  faHeart,
  faChartLine,
  faMapMarkerAlt,
  faPalette,
  faHeadset,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

export default function Clients() {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await api.get("/admin/api/Client/GetAll");
        setClients(response.data);
      } catch (err) {
        console.error("Error fetching clients:", err);
      }
    };
    fetchClients();
  }, []);

  return (
    <div className="Clients">
      <NavBar />

      {/* Hero Section */}
      <section className="clients-hero">
        <div className="clients-hero-content container">
          <h1>Our Valued Clients</h1>
          <p>
            Partnering with leading brands to create impactful advertising
            campaigns
          </p>
          <div className="clients-hero-stats">
            <div className="clients-hero-stat">
              <FontAwesomeIcon icon={faBuilding} />
              <span>500+ Brands Partnered</span>
            </div>
            <div className="clients-hero-stat">
              <FontAwesomeIcon icon={faCrown} />
              <span>50+ Industry Leaders</span>
            </div>
            <div className="clients-hero-stat">
              <FontAwesomeIcon icon={faStar} />
              <span>98% Client Retention</span>
            </div>
            <div className="clients-hero-stat">
              <FontAwesomeIcon icon={faHeart} />
              <span>95% Client Satisfaction</span>
            </div>
          </div>
        </div>
        <div className="clients-hero-overlay"></div>
      </section>

      {/* Why Choose Us Section - Above Slider */}
      <section className="why-choose-us">
        <div className="container">
          <div className="clients-section-header">
            <h2>Why Leading Brands Choose Spark</h2>
            <p>
              Discover what sets us apart in the outdoor advertising industry
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faChartLine} />
              </div>
              <h3>Proven Results</h3>
              <p>
                Our campaigns deliver measurable ROI and significant brand
                visibility increases
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <h3>Prime Locations</h3>
              <p>
                Strategic billboard placements in high-traffic areas for maximum
                exposure
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faPalette} />
              </div>
              <h3>Creative Excellence</h3>
              <p>
                Captivating designs that transform your message into visual
                impact
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faHeadset} />
              </div>
              <h3>Dedicated Support</h3>
              <p>Personal account management and 24/7 campaign monitoring</p>
            </div>
          </div>
        </div>
      </section>

      {/* Clients Slider Section */}
      <div className="clients-slider-container">
        <div className="slider-header">
          <h2>Our Prestigious Clients</h2>
          <p>Trusted by industry leaders and innovative brands</p>
        </div>
        <div className="slider-track">
          <Swiper
            modules={[Autoplay, FreeMode]}
            spaceBetween={40}
            slidesPerView={"auto"}
            speed={5000}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
              reverseDirection: false,
            }}
            loop={true}
            freeMode={{
              enabled: true,
              momentum: true,
              momentumRatio: 0.5,
              momentumBounce: true,
              momentumBounceRatio: 0.5,
            }}
            allowTouchMove={false}
            resistance={false}
            resistanceRatio={0}
            className="auto-slider"
          >
            {clients.map((client) => (
              <Swiper
                modules={[Autoplay, FreeMode]}
                spaceBetween={40}
                slidesPerView={"auto"}
                speed={5000}
                autoplay={{
                  delay: 0,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  reverseDirection: false,
                }}
                loop={true}
                freeMode={{
                  enabled: true,
                  momentum: true,
                  momentumRatio: 0.5,
                  momentumBounce: true,
                  momentumBounceRatio: 0.5,
                }}
                allowTouchMove={false}
                resistance={false}
                resistanceRatio={0}
                className="auto-slider"
              >
                {clients.map((client) => (
                  <SwiperSlide key={client.id} className="client-slide">
                    <div className="client-logo-item">
                      {client.logoUrl && (
                        <img
                          src={`${client.logoUrl}?t=${Date.now()}`}
                          alt={client.name}
                          className="client-logo"
                          loading="lazy"
                        />
                      )}
                      <div className="client-info">
                        <h4 className="client-name">{client.name}</h4>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Join Our Clients Section - Below Slider */}
      <section className="join-clients">
        <div className="container">
          <div className="join-content">
            <div className="join-text">
              <h2>Join Our Prestigious Client Portfolio</h2>
              <p>
                Become part of our success story and elevate your brand with our
                premium advertising solutions
              </p>
              <div className="benefits-list">
                <div className="benefit-item">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="benefit-icon"
                  />
                  <span>Customized campaign strategies</span>
                </div>
                <div className="benefit-item">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="benefit-icon"
                  />
                  <span>Competitive pricing packages</span>
                </div>
                <div className="benefit-item">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="benefit-icon"
                  />
                  <span>Detailed performance analytics</span>
                </div>
                <div className="benefit-item">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="benefit-icon"
                  />
                  <span>Flexible contract terms</span>
                </div>
              </div>
              <button className="cta-button">Start Your Campaign Now</button>
            </div>
            <div className="join-visual">
              <div className="stat-highlight">
                <div className="stat-number">78%</div>
                <div className="stat-label">Client Growth Rate</div>
              </div>
              <div className="stat-highlight">
                <div className="stat-number">4.9/5</div>
                <div className="stat-label">Client Satisfaction Score</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
